import React, { useContext } from 'react'
import { ListGroup, ListGroupItem, Badge } from 'reactstrap'
import { useTranslation } from 'react-i18next'

import BaseContainer from '../common/BaseContainer'
import ControlHeader from '../common/ControlHeader'

import useCrudModals from '../common/FormModalContent/useCrudModals'
import {
  formsInputsData,
  initialValues,
  requestToFormData,
  formToRequestData,
  baseUrl,
  validationSchema,
} from './config'
import generateFormikInputs from '../../utils/generateFormikInputs'
import useFetch from '../../utils/useFetch'
import EditButton from '../common/buttons/EditButton'
import { ModalManagerContext } from '../ModalsManager'

import useStyles from './styles'

const Placements = () => {
  const { t } = useTranslation(['translation', 'COMMON'])

  const openModal = useContext(ModalManagerContext)

  const { data, update, render } = useFetch(`${process.env.REACT_APP_API_URL}/placement/`, openModal)

  const classes = useStyles();
  const { openEditModal } = useCrudModals(
    openModal,
    {
      entity: t('PLACEMENT.ENTITY_NAME'),
      baseUrl,
      requestToFormData,
      formToRequestData,
      initialValues,
      FormSchema: validationSchema,
      afterSuccecss: update,
      createFormComponent: formikProps => (
        <div className={classes.inputsGrid}>
          {generateFormikInputs(formsInputsData, formikProps, true)}
        </div>
      ),
    },
  )

  const totalAps = data?.reduce((total, val) => total + val.accessPoint.macs.length, 0)
  return (
    <BaseContainer>
      <ControlHeader
        title={t('PLACEMENT.TITLE_TAB')}
        badge={t('PLACEMENT.AP_WITH_COUNT', { count: totalAps || 0 })}
        showBadge
        showTabs
        activeTab="placements"
      // onAdd={openCreateModal}
      />
      {render(() => (
        <div className={classes.scrollerWrapper}>
          <ListGroup>
            {data.map(
              (val) => {
                const numAps = val.accessPoint.macs.length
                return (
                  <ListGroupItem key={val._id} className={classes.listItem}>
                    <div className={classes.itemWithBadges}>
                      {val.name}
                      <Badge pill className={classes.badge}>{t('PLACEMENT.AP_WITH_COUNT', { count: numAps })}</Badge>
                    </div>
                    <div className={classes.btnGroup}>
                      {/* <DeleteButton onClick={() => { openDeleteModal(val._id, val.name); }} /> */}
                      <EditButton onClick={() => { openEditModal(val._id); }} />
                    </div>
                  </ListGroupItem>
                )
              },
            )}
          </ListGroup>
        </div>
      ))}
    </BaseContainer>
  );
};


export default Placements
